import React from "react";
import { Box, Stepper, Step, StepLabel } from "@mui/material";

interface StepProgressBarProps {
  steps: { label: string }[];
  activeStep: number;
}

const StepProgressBar: React.FC<StepProgressBarProps> = ({ steps, activeStep }) => {
  return (
    <Box mb={4} >
      <Stepper activeStep={activeStep}>
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepProgressBar;
